@if (user && user.type !== eUserAccountType.Anonymous) {
  <app-favorite-manager [item]="mainItem" [favorite]="favorite"></app-favorite-manager>
}
<div class="item-desc">
  {{mainItem.summary}}
</div>
@if (mainItem.mainType === MainType.Item) {
  <app-character-list [relatedMainItems]="relatedMainItems" [relations]="itemCastCharacterRelations"></app-character-list>
}
@if (mainItem.mainType === MainType.Character) {
  <app-character-item-cast-list [relationMainItems]="relatedMainItems" [relations]="itemCastCharacterRelations"></app-character-item-cast-list>
}
@if (mainItem.mainType === MainType.Person) {
  <app-cast-character-item-list [relationMainItems]="relatedMainItems" [relations]="itemCastCharacterRelations"></app-cast-character-item-list>
}
